import {isArray, isObject} from "underscore";
import System from "../../helper/system";
import Helper from "../../support/Helper";
import store from "../../storeWire";

class documentResponseMaker {
    data = [];
    data_to_send = documentResponseMaker.defaultData();

    static defaultData = () => {
        return {
            documentList: [],
            count: 0,
            facets: {
                DocumentType: {},
                FileFormat: {},
                Manufacturer: {},
            },
        };
    };

    constructor(data) {
        this.data = data;
    }

    getTheKeyForThisAPIMaker = (key) => {
        return System.getTheKeyForThisAPIMaker(key);
    };

    process = async () => {
        this.data_to_send = documentResponseMaker.defaultData();
        let state = store.getState();
        let documentContent_facets = {};
        if (state.entities.model_HomePageContent.documentContent !== undefined &&
            state.entities.model_HomePageContent.documentContent.facets !== undefined
        ) {
            documentContent_facets = state.entities.model_HomePageContent.documentContent.facets;
            documentContent_facets = {...documentContent_facets};
        }
        if (this.data.data.Documents !== undefined) {
            this.data.data.Documents.map((v, i) => {
                v.DatePublishedObjectString = Helper.dateFormatFromString(v['DatePublished'],true);
                this.data_to_send.documentList.push(v);
            })
        }
        if (this.data.data.Count !== undefined) {
            this.data_to_send.count = this.data.data.Count;
        }


        if (documentContent_facets['DocumentType'] !== undefined && isObject(documentContent_facets['DocumentType']) &&
            Object.entries(documentContent_facets['DocumentType']).length > 0
        ) {
            Object.entries(documentContent_facets['DocumentType']).map((v) => {
                let value = {...v[1]};
                if (this.data_to_send.facets.DocumentType[v[1].slug] === undefined) {
                    value.disabled = true;
                } else {
                    value.disabled = false;
                }
                this.data_to_send.facets.DocumentType[v[1].slug] = value;
            });
        }
        if (this.data.data.DocumentType !== undefined && isArray(this.data.data.DocumentType)) {
            this.data.data.DocumentType.map((v, i) => {
                v.slug = this.getTheKeyForThisAPIMaker(v.Name);
                v.disabled = false;
                this.data_to_send.facets.DocumentType[v.slug] = v;
            });
        }
        if (documentContent_facets['FileFormat'] !== undefined && isObject(documentContent_facets['FileFormat']) &&
            Object.entries(documentContent_facets['FileFormat']).length > 0
        ) {
            Object.entries(documentContent_facets['FileFormat']).map((v) => {
                let value = {...v[1]};
                if (this.data_to_send.facets.FileFormat[v[1].slug] === undefined) {
                    value.disabled = true;
                } else {
                    value.disabled = false;
                }
                this.data_to_send.facets.FileFormat[v[1].slug] = value;
            });
        }
        if (this.data.data.FileFormat !== undefined && isArray(this.data.data.FileFormat)) {
            this.data.data.FileFormat.map((v, i) => {
                v.slug = this.getTheKeyForThisAPIMaker(v.Name);
                v.disabled = false;
                this.data_to_send.facets.FileFormat[v.slug] = v;
            })
        }
        if (documentContent_facets['Manufacturer'] !== undefined && isObject(documentContent_facets['Manufacturer']) &&
            Object.entries(documentContent_facets['Manufacturer']).length > 0
        ) {
            Object.entries(documentContent_facets['Manufacturer']).map((v) => {
                let value = {...v[1]};
                if (this.data_to_send.facets.Manufacturer[v[1].slug] === undefined) {
                    value.disabled = true;
                } else {
                    value.disabled = false;
                }
                this.data_to_send.facets.Manufacturer[v[1].slug] = value;
            });
        }
        if (this.data.data.Manufacturer !== undefined && isArray(this.data.data.Manufacturer)) {
            this.data.data.Manufacturer.map((v, i) => {
                v.slug = this.getTheKeyForThisAPIMaker(v.Name);
                v.disabled = false;
                this.data_to_send.facets.Manufacturer[v.slug] = v;
            })
        }
        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return {
            data: this.data_to_send
        };
    };
}

export default documentResponseMaker;